import React, { useEffect, useState, useContext } from "react";

import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";

import useSettings from "../../hooks/useSettings";

import { makeStyles } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";

import { Tab, Tabs, TextField, Divider } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import useCompanySettings from "../../hooks/useSettings/companySettings";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 240,
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontFamily: '"Inter", "Poppins", sans-serif',
      "& fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.12)" : "#E2E8F0",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.2)" : "#CBD5E1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#35af9a",
      },
    },
    "& .MuiInputLabel-outlined": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      "&.Mui-focused": {
        color: "#35af9a",
      },
    },
    "& .MuiSelect-select": {
      fontFamily: '"Inter", "Poppins", sans-serif',
    },
  },
  textField: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontFamily: '"Inter", "Poppins", sans-serif',
      "& fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.12)" : "#E2E8F0",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.2)" : "#CBD5E1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#35af9a",
      },
    },
    "& .MuiInputLabel-outlined": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      "&.Mui-focused": {
        color: "#35af9a",
      },
    },
  },
  tab: {
    borderBottom: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#E2E8F0"}`,
    width: "100%",
    "& .MuiTabs-flexContainer": {
      justifyContent: "center"
    },
    "& .MuiTab-root": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      fontWeight: 600,
      fontSize: 14,
      textTransform: "none",
      minWidth: 120,
      "&.Mui-selected": {
        color: "#35af9a",
      },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#35af9a",
      height: 3,
      borderRadius: "3px 3px 0 0",
    },
  },
  menuItem: {
    fontFamily: '"Inter", "Poppins", sans-serif',
  },
  switchContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: theme.spacing(1, 0),
  },
  switchLabel: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.type === "dark" ? "#F1F5F9" : "#1E293B",
  },
  switchWrapper: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  optionsGrid: {
    "& > .MuiGrid-item": {
      position: "relative",
      "&::after": {
        content: '""',
        position: "absolute",
        top: "16px",
        bottom: "16px",
        right: 0,
        width: 1,
        backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
      },
      [theme.breakpoints.up("md")]: {
        "&:nth-child(3n)::after": {
          display: "none",
        },
      },
      [theme.breakpoints.only("sm")]: {
        "&:nth-child(2n)::after": {
          display: "none",
        },
      },
      [theme.breakpoints.down("xs")]: {
        "&::after": {
          display: "none",
        },
      },
    }
  },
}));

// Switch verde customizado
const GreenSwitch = withStyles((theme) => ({
  switchBase: {
    color: theme.palette.type === "dark" ? "#64748B" : "#CBD5E1",
    "&$checked": {
      color: "#35af9a",
    },
    "&$checked + $track": {
      backgroundColor: "#35af9a",
    },
  },
  checked: {},
  track: {
    backgroundColor: theme.palette.type === "dark" ? "#475569" : "#E2E8F0",
  },
}))(Switch);

export default function Options(props) {
  const { oldSettings, settings, scheduleTypeChanged, user } = props;

  const classes = useStyles();
  const [userRating, setUserRating] = useState(false);
  const [scheduleType, setScheduleType] = useState("disabled");
  const [chatBotType, setChatBotType] = useState("text");

  const [loadingUserRating, setLoadingUserRating] = useState(false);
  const [loadingScheduleType, setLoadingScheduleType] = useState(false);

  const [userCreation, setUserCreation] = useState(false);
  const [loadingUserCreation, setLoadingUserCreation] = useState(false);

  const [SendGreetingAccepted, setSendGreetingAccepted] = useState(true);
  const [loadingSendGreetingAccepted, setLoadingSendGreetingAccepted] = useState(false);

  const [UserRandom, setUserRandom] = useState(true);
  const [loadingUserRandom, setLoadingUserRandom] = useState(false);

  const [SettingsTransfTicket, setSettingsTransfTicket] = useState(true);
  const [loadingSettingsTransfTicket, setLoadingSettingsTransfTicket] = useState(false);

  const [AcceptCallWhatsapp, setAcceptCallWhatsapp] = useState(true);
  const [loadingAcceptCallWhatsapp, setLoadingAcceptCallWhatsapp] = useState(false);

  const [sendSignMessage, setSendSignMessage] = useState(true);
  const [loadingSendSignMessage, setLoadingSendSignMessage] = useState(false);

  const [sendGreetingMessageOneQueues, setSendGreetingMessageOneQueues] = useState(true);
  const [loadingSendGreetingMessageOneQueues, setLoadingSendGreetingMessageOneQueues] = useState(false);

  const [sendQueuePosition, setSendQueuePosition] = useState(true);
  const [loadingSendQueuePosition, setLoadingSendQueuePosition] = useState(false);

  const [sendFarewellWaitingTicket, setSendFarewellWaitingTicket] = useState(true);
  const [loadingSendFarewellWaitingTicket, setLoadingSendFarewellWaitingTicket] = useState(false);

  const [acceptAudioMessageContact, setAcceptAudioMessageContact] = useState(true);
  const [loadingAcceptAudioMessageContact, setLoadingAcceptAudioMessageContact] = useState(false);

  //LGPD
  const [enableLGPD, setEnableLGPD] = useState(false);
  const [loadingEnableLGPD, setLoadingEnableLGPD] = useState(false);

  const [lgpdMessage, setLGPDMessage] = useState("");
  const [loadinglgpdMessage, setLoadingLGPDMessage] = useState(false);

  const [lgpdLink, setLGPDLink] = useState("");
  const [loadingLGPDLink, setLoadingLGPDLink] = useState(false);

  const [lgpdDeleteMessage, setLGPDDeleteMessage] = useState(false);
  const [loadingLGPDDeleteMessage, setLoadingLGPDDeleteMessage] = useState(false);

  const [lgpdConsent, setLGPDConsent] = useState(false);
  const [loadingLGPDConsent, setLoadingLGPDConsent] = useState(false);

  const [lgpdHideNumber, setLGPDHideNumber] = useState(false);
  const [loadingLGPDHideNumber, setLoadingLGPDHideNumber] = useState(false);

  // Tag obrigatoria
  const [requiredTag, setRequiredTag] = useState(true)
  const [loadingRequiredTag, setLoadingRequiredTag] = useState(false)

  const [sendMessageOutExpedientTicketOpen, setSendMessageOutExpedientTicketOpen] = useState(true);
  const [loadingSendMessageOutExpedientTicketOpen, setLoadingSendMessageOutExpedientTicketOpen] = useState(false);

  const [asaasToken, setAsaasToken] = useState("");
  const [loadingAsaasToken, setLoadingAsaasToken] = useState(false);

  const [geminiApiKey, setGeminiApiKey] = useState("");
  const [loadingGeminiApiKey, setLoadingGeminiApiKey] = useState(false);
  const { update:updateUserCreation, getAll } = useSettings();

  const { update } = useCompanySettings();

  const isSuper = () => {
    return user.super;
  };

  
  useEffect(() => {
    
    if (Array.isArray(oldSettings) && oldSettings.length) {

      const userPar = oldSettings.find((s) => s.key === "userCreation");

      if (userPar) {
        setUserCreation(userPar.value === "enabled");
      }
    }
  }, [oldSettings])
  

  useEffect(() => {
    for (const [key, value] of Object.entries(settings)) {
      if (key === "userRating") setUserRating(value === "enabled");
      if (key === "scheduleType") setScheduleType(value);
      if (key === "chatBotType") setChatBotType(value);
      if (key === "acceptCallWhatsapp") setAcceptCallWhatsapp(value === "enabled");
      if (key === "userRandom") setUserRandom(value === "enabled");
      if (key === "sendGreetingMessageOneQueues") setSendGreetingMessageOneQueues(value === "enabled");
      if (key === "sendSignMessage") setSendSignMessage(value === "enabled");
      if (key === "sendFarewellWaitingTicket") setSendFarewellWaitingTicket(value === "enabled");
      if (key === "sendGreetingAccepted") setSendGreetingAccepted(value === "enabled");
      if (key === "sendMessageOutExpedientTicketOpen") setSendMessageOutExpedientTicketOpen(value === "enabled")
      if (key === "sendQueuePosition") setSendQueuePosition(value === "enabled");
      if (key === "acceptAudioMessageContact") setAcceptAudioMessageContact(value === "enabled");
      if (key === "enableLGPD") setEnableLGPD(value === "enabled");
      if (key === "requiredTag") setRequiredTag(value === "enabled");
      if (key === "lgpdDeleteMessage") setLGPDDeleteMessage(value === "enabled")
      if (key === "lgpdHideNumber") setLGPDHideNumber(value === "enabled");
      if (key === "lgpdConsent") setLGPDConsent(value === "enabled");
      if (key === "lgpdMessage") setLGPDMessage(value);
      if (key === "sendMsgTransfTicket") setSettingsTransfTicket(value === "enabled")
      if (key === "lgpdLink") setLGPDLink(value)
      if (key === "asaas") setAsaasToken(value);
      if (key === "geminiApiKey") setGeminiApiKey(value);
    }    
  }, [settings]);

  async function handleChangeUserCreation(value) {
    setUserCreation(value);
    setLoadingUserCreation(true);
    await updateUserCreation({
      key: "userCreation",
      value: value ? "enabled" : "disabled",
    });
    setLoadingUserCreation(false);
  }

  async function handleChangeUserRating(value) {
    setUserRating(value);
    setLoadingUserRating(true);
    await update({
      column:"userRating",
      data: value ? "enabled" : "disabled"
    });
    setLoadingUserRating(false);
  }

  async function handleScheduleType(value) {
    setScheduleType(value);
    setLoadingScheduleType(true);
    await update({
      column:"scheduleType",
      data:value
    });
    setLoadingScheduleType(false);
    if (typeof scheduleTypeChanged === "function") {
      scheduleTypeChanged(value);
    }
  }

  async function handleChatBotType(value) {
    setChatBotType(value);
    await update({
      column:"chatBotType",
      data:value
    });
    if (typeof scheduleTypeChanged === "function") {
      setChatBotType(value);
    }
  }

  async function handleLGPDMessage(value) {
    setLGPDMessage(value);
    setLoadingLGPDMessage(true);
    await update({
      column:"lgpdMessage",
      data:value
    });
    setLoadingLGPDMessage(false);
  }

  async function handleLGPDLink(value) {
    setLGPDLink(value);
    setLoadingLGPDLink(true);
    await update({
      column:"lgpdLink",
      data:value
    });
    setLoadingLGPDLink(false);
  }

  async function handleLGPDDeleteMessage(value) {
    setLGPDDeleteMessage(value);
    setLoadingLGPDDeleteMessage(true);
    await update({
      column:"lgpdDeleteMessage",
      data: value ? "enabled" : "disabled"
    });
    setLoadingLGPDDeleteMessage(false);
  }

  async function handleLGPDConsent(value) {
    setLGPDConsent(value);
    setLoadingLGPDConsent(true);
    await update({
      column:"lgpdConsent",
      data: value ? "enabled" : "disabled"
    });
    setLoadingLGPDConsent(false);
  }

  async function handleLGPDHideNumber (value) {
    setLGPDHideNumber(value);
    setLoadingLGPDHideNumber(true);
    await update({
      column:"lgpdHideNumber",
      data: value ? "enabled" : "disabled"
    });
    setLoadingLGPDHideNumber(false);
  }

  async function handleSendGreetingAccepted(value) {
    setSendGreetingAccepted(value);
    setLoadingSendGreetingAccepted(true);
    await update({
      column:"sendGreetingAccepted",
      data: value ? "enabled" : "disabled"
    });
    setLoadingSendGreetingAccepted(false);
  }

  async function handleUserRandom(value) {
    setUserRandom(value);
    setLoadingUserRandom(true);
    await update({
      column:"userRandom",
      data: value ? "enabled" : "disabled"
    });
    setLoadingUserRandom(false);
  }

  async function handleSettingsTransfTicket(value) {
    setSettingsTransfTicket(value);
    setLoadingSettingsTransfTicket(true);
    await update({
      column:"sendMsgTransfTicket",
      data: value ? "enabled" : "disabled"
    });
    setLoadingSettingsTransfTicket(false);
  }

  async function handleAcceptCallWhatsapp(value) {
    setAcceptCallWhatsapp(value);
    setLoadingAcceptCallWhatsapp(true);
    await update({
      column:"acceptCallWhatsapp",
      data: value ? "enabled" : "disabled"
    });
    setLoadingAcceptCallWhatsapp(false);
  }

  async function handleSendSignMessage(value) {
    setSendSignMessage(value);
    setLoadingSendSignMessage(true);
    await update({
      column:"sendSignMessage",
      data: value ? "enabled" : "disabled"
    });
    localStorage.setItem("sendSignMessage", value); //atualiza localstorage para sessão
    setLoadingSendSignMessage(false);
  }

  async function handleSendGreetingMessageOneQueues(value) {
    setSendGreetingMessageOneQueues(value);
    setLoadingSendGreetingMessageOneQueues(true);
    await update({
      column:"sendGreetingMessageOneQueues",
      data: value ? "enabled" : "disabled"
    });
    setLoadingSendGreetingMessageOneQueues(false);
  }

  async function handleSendQueuePosition(value) {
    setSendQueuePosition(value);
    setLoadingSendQueuePosition(true);
    await update({
      column:"sendQueuePosition",
      data: value ? "enabled" : "disabled"
    });
    setLoadingSendQueuePosition(false);
  }

  async function handleSendFarewellWaitingTicket(value) {
    setSendFarewellWaitingTicket(value);
    setLoadingSendFarewellWaitingTicket(true);
    await update({
      column:"sendFarewellWaitingTicket",
      data: value ? "enabled" : "disabled"
    });
    setLoadingSendFarewellWaitingTicket(false);
  }

  async function handleAcceptAudioMessageContact(value) {
    setAcceptAudioMessageContact(value);
    setLoadingAcceptAudioMessageContact(true);
    await update({
      column:"acceptAudioMessageContact",
      data: value ? "enabled" : "disabled"
    });
    setLoadingAcceptAudioMessageContact(false);
  }

  async function handleEnableLGPD(value) {
    setEnableLGPD(value);
    setLoadingEnableLGPD(true);
    await update({
      column:"enableLGPD",
      data: value ? "enabled" : "disabled"
    });
    setLoadingEnableLGPD(false);
  }

  async function handleRequiredTag(value) {
    setRequiredTag(value);
    setLoadingRequiredTag(true);
    await update({
      column: "requiredTag",
      data:value,
    });
    setLoadingRequiredTag(false);
  }

  async function handleAsaasToken(value) {
    setAsaasToken(value);
    setLoadingAsaasToken(true);
    await update({
      column:"asaas",
      data:value
    });
    setLoadingAsaasToken(false);
  }

  async function handleGeminiApiKey(value) {
    setGeminiApiKey(value);
    setLoadingGeminiApiKey(true);
    await update({
      column: "geminiApiKey",
      data: value
    });
    setLoadingGeminiApiKey(false);
  }

  async function handleSendMessageOutExpedientTicketOpen(value) {
    setLoadingSendMessageOutExpedientTicketOpen(true);
    setSendMessageOutExpedientTicketOpen(value);
    await update({
      column:"sendMessageOutExpedientTicketOpen",
      data: value ? "enabled" : "disabled"
    });
    setLoadingSendMessageOutExpedientTicketOpen(false);
  }


  return (
    <>
      <Grid spacing={3} container className={classes.optionsGrid}>

        {/* CRIAÇÃO DE COMPANY/USERS */}
        {isSuper() ?
          <Grid xs={12} sm={6} md={4} item>
            <Box className={classes.switchContainer}>
              <Typography className={classes.switchLabel}>
                {i18n.t("settings.settings.options.creationCompanyUser")}
              </Typography>
              <Box className={classes.switchWrapper}>
                {loadingUserCreation && (
                  <CircularProgress size={16} style={{ color: "#35af9a" }} />
                )}
                <GreenSwitch
                  checked={userCreation}
                  onChange={async (e) => {
                    handleChangeUserCreation(e.target.checked);
                  }}
                  disabled={loadingUserCreation}
                />
              </Box>
            </Box>
          </Grid>
          : null}

        {/* AVALIAÇÕES */}
        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.evaluations")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingUserRating && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={userRating}
                onChange={async (e) => {
                  handleChangeUserRating(e.target.checked);
                }}
                disabled={loadingUserRating}
              />
            </Box>
          </Box>
        </Grid>

        {/* ENVIAR SAUDAÇÃO AO ACEITAR O TICKET */}
        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.sendGreetingAccepted")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingSendGreetingAccepted && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={SendGreetingAccepted}
                onChange={async (e) => {
                  handleSendGreetingAccepted(e.target.checked);
                }}
                disabled={loadingSendGreetingAccepted}
              />
            </Box>
          </Box>
        </Grid>

        {/* ESCOLHER OPERADOR ALEATORIO */}
        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.userRandom")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingUserRandom && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={UserRandom}
                onChange={async (e) => {
                  handleUserRandom(e.target.checked);
                }}
                disabled={loadingUserRandom}
              />
            </Box>
          </Box>
        </Grid>

        {/* ENVIAR MENSAGEM DE TRANSFERENCIA DE SETOR/ATENDENTE */}
        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.sendMsgTransfTicket")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingSettingsTransfTicket && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={SettingsTransfTicket}
                onChange={async (e) => {
                  handleSettingsTransfTicket(e.target.checked);
                }}
                disabled={loadingSettingsTransfTicket}
              />
            </Box>
          </Box>
        </Grid>

        {/* AVISO SOBRE LIGAÇÃO DO WHATSAPP */}
        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.acceptCallWhatsapp")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingAcceptCallWhatsapp && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={AcceptCallWhatsapp}
                onChange={async (e) => {
                  handleAcceptCallWhatsapp(e.target.checked);
                }}
                disabled={loadingAcceptCallWhatsapp}
              />
            </Box>
          </Box>
        </Grid>

        {/* HABILITAR PARA O ATENDENTE RETIRAR O ASSINATURA */}
        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.sendSignMessage")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingSendSignMessage && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={sendSignMessage}
                onChange={async (e) => {
                  handleSendSignMessage(e.target.checked);
                }}
                disabled={loadingSendSignMessage}
              />
            </Box>
          </Box>
        </Grid>

        {/* ENVIAR SAUDAÇÃO QUANDO HOUVER SOMENTE 1 FILA */}
        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.sendGreetingMessageOneQueues")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingSendGreetingMessageOneQueues && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={sendGreetingMessageOneQueues}
                onChange={async (e) => {
                  handleSendGreetingMessageOneQueues(e.target.checked);
                }}
                disabled={loadingSendGreetingMessageOneQueues}
              />
            </Box>
          </Box>
        </Grid>

        {/* ENVIAR MENSAGEM COM A POSIÇÃO DA FILA */}
        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.sendQueuePosition")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingSendQueuePosition && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={sendQueuePosition}
                onChange={async (e) => {
                  handleSendQueuePosition(e.target.checked);
                }}
                disabled={loadingSendQueuePosition}
              />
            </Box>
          </Box>
        </Grid>

        {/* ENVIAR MENSAGEM DE DESPEDIDA NO AGUARDANDO */}
        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.sendFarewellWaitingTicket")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingSendFarewellWaitingTicket && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={sendFarewellWaitingTicket}
                onChange={async (e) => {
                  handleSendFarewellWaitingTicket(e.target.checked);
                }}
                disabled={loadingSendFarewellWaitingTicket}
              />
            </Box>
          </Box>
        </Grid>

        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.acceptAudioMessageContact")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingAcceptAudioMessageContact && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={acceptAudioMessageContact}
                onChange={async (e) => {
                  handleAcceptAudioMessageContact(e.target.checked);
                }}
                disabled={loadingAcceptAudioMessageContact}
              />
            </Box>
          </Box>
        </Grid>

        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.enableLGPD")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingEnableLGPD && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={enableLGPD}
                onChange={async (e) => {
                  handleEnableLGPD(e.target.checked);
                }}
                disabled={loadingEnableLGPD}
              />
            </Box>
          </Box>
        </Grid>

        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.requiredTag")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingRequiredTag && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={requiredTag}
                onChange={async (e) => {
                  handleRequiredTag(e.target.checked);
                }}
                disabled={loadingRequiredTag}
              />
            </Box>
          </Box>
        </Grid>    
        <Grid xs={12} sm={6} md={4} item>
          <Box className={classes.switchContainer}>
            <Typography className={classes.switchLabel}>
              {i18n.t("settings.settings.options.sendMessageOutExpedientTicketOpen")}
            </Typography>
            <Box className={classes.switchWrapper}>
              {loadingSendMessageOutExpedientTicketOpen && (
                <CircularProgress size={16} style={{ color: "#35af9a" }} />
              )}
              <GreenSwitch
                checked={sendMessageOutExpedientTicketOpen}
                onChange={async (e) => {
                  handleSendMessageOutExpedientTicketOpen(e.target.checked);
                }}
                disabled={loadingSendMessageOutExpedientTicketOpen}
              />
            </Box>
          </Box>
        </Grid>

        {/* AGENDAMENTO DE EXPEDIENTE */}
        <Grid xs={12} sm={6} md={4} item>
          <TextField
            select
            label={i18n.t("settings.settings.options.officeScheduling")}
            value={scheduleType}
            onChange={async (e) => {
              handleScheduleType(e.target.value);
            }}
            variant="outlined"
            margin="dense"
            fullWidth
            className={classes.textField}
            disabled={loadingScheduleType}
          >
            <MenuItem className={classes.menuItem} value={"disabled"}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
            <MenuItem className={classes.menuItem} value={"queue"}>{i18n.t("settings.settings.options.queueManagement")}</MenuItem>
            <MenuItem className={classes.menuItem} value={"company"}>{i18n.t("settings.settings.options.companyManagement")}</MenuItem>
            <MenuItem className={classes.menuItem} value={"connection"}>{i18n.t("settings.settings.options.connectionManagement")}</MenuItem>
          </TextField>
          {loadingScheduleType && (
            <FormHelperText style={{ marginTop: 4 }}>
              {i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          )}
        </Grid>

        {/* TIPO DO BOT */}
        <Grid xs={12} sm={6} md={4} item>
          <TextField
            select
            label={i18n.t("settings.settings.options.chatBotType")}
            value={chatBotType}
            onChange={async (e) => {
              handleChatBotType(e.target.value);
            }}
            variant="outlined"
            margin="dense"
            fullWidth
            className={classes.textField}
            disabled={loadingScheduleType}
          >
            <MenuItem className={classes.menuItem} value={"text"}>Texto</MenuItem>
            <MenuItem className={classes.menuItem} value={"button"}>{i18n.t("settings.settings.options.buttons")}</MenuItem>
            <MenuItem className={classes.menuItem} value={"list"}>{i18n.t("settings.settings.options.lists")}</MenuItem>
          </TextField>
          {loadingScheduleType && (
            <FormHelperText style={{ marginTop: 4 }}>
              {i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          )}
        </Grid>
      </Grid>
      <Divider style={{ margin: "24px 0" }} />
      {/*-----------------ASAAS-----------------*/}
      <Grid spacing={3} container
        style={{ marginBottom: 10 }}>
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="on"
          variant="scrollable"
          className={classes.tab}
        >
          <Tab label="ASAAS" />

        </Tabs>
        <Grid xs={12} sm={12} md={12} item>
          <FormControl className={classes.selectContainer}>
              <TextField
                id="asaas"
                name="asaas"
                margin="dense"
                label="Token Asaas"
                variant="outlined"
                value={asaasToken}
                onChange={async (e) => {
                  handleAsaasToken(e.target.value);
                }}
                className={classes.textField}
              >
            </TextField>
          </FormControl>
        </Grid>
      </Grid>
      <Divider style={{ margin: "24px 0" }} />
      {/*-----------------GEMINI-----------------*/}
      <Grid spacing={3} container
        style={{ marginBottom: 10 }}>
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="on"
          variant="scrollable"
          className={classes.tab}
        >
          <Tab label="Gemini AI" />
        </Tabs>
        <Grid xs={12} sm={12} md={12} item>
          <FormControl className={classes.selectContainer}>
              <TextField
                id="geminiApiKey"
                name="geminiApiKey"
                margin="dense"
                label={i18n.t("settings.settings.options.geminiApiKey")}
                variant="outlined"
                value={geminiApiKey}
                type="password"
                onChange={async (e) => {
                  handleGeminiApiKey(e.target.value);
                }}
                className={classes.textField}
              />
          </FormControl>
        </Grid>
      </Grid>
      <Divider style={{ margin: "24px 0" }} />
      {/*-----------------LGPD-----------------*/}
      {enableLGPD && (
      <>
        <Grid spacing={3} container
          style={{ marginTop: 10, marginBottom: 10 }}>
          <Tabs
            value={0}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="on"
            variant="scrollable"
            className={classes.tab}
          >
            <Tab

              label={i18n.t("settings.settings.LGPD.title")} />

          </Tabs>
        </Grid>
        <Grid spacing={3} container>
          <Grid xs={12} sm={6} md={12} item>
            <FormControl className={classes.selectContainer}>
              <TextField
                id="lgpdMessage"
                name="lgpdMessage"
                margin="dense"
                multiline
                rows={3}
                label={i18n.t("settings.settings.LGPD.welcome")}
                variant="outlined"
                value={lgpdMessage}
                onChange={async (e) => {
                  handleLGPDMessage(e.target.value);
                }}
                className={classes.textField}
              >
              </TextField>
              <FormHelperText>
                {loadinglgpdMessage && i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid xs={12} sm={6} md={12} item>
            <FormControl className={classes.selectContainer}>
              <TextField
                id="lgpdLink"
                name="lgpdLink"
                margin="dense"
                label={i18n.t("settings.settings.LGPD.linkLGPD")}
                variant="outlined"
                value={lgpdLink}
                onChange={async (e) => {
                  handleLGPDLink(e.target.value);
                }}
                className={classes.textField}
              >
              </TextField>
              <FormHelperText>
                {loadingLGPDLink && i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <Grid spacing={3} container className={classes.optionsGrid}>
          {/* LGPD Manter ou nao mensagem deletada pelo contato */}
          <Grid xs={12} sm={6} md={4} item>
            <Box className={classes.switchContainer}>
              <Typography className={classes.switchLabel}>
                {i18n.t("settings.settings.LGPD.obfuscateMessageDelete")}
              </Typography>
              <Box className={classes.switchWrapper}>
                {loadingLGPDDeleteMessage && (
                  <CircularProgress size={16} style={{ color: "#35af9a" }} />
                )}
                <GreenSwitch
                  checked={lgpdDeleteMessage}
                  onChange={async (e) => {
                    handleLGPDDeleteMessage(e.target.checked);
                  }}
                  disabled={loadingLGPDDeleteMessage}
                />
              </Box>
            </Box>
          </Grid>
          {/* LGPD Sempre solicitar confirmaçao / conscentimento dos dados */}
          <Grid xs={12} sm={6} md={4} item>
            <Box className={classes.switchContainer}>
              <Typography className={classes.switchLabel}>
                {i18n.t("settings.settings.LGPD.alwaysConsent")}
              </Typography>
              <Box className={classes.switchWrapper}>
                {loadingLGPDConsent && (
                  <CircularProgress size={16} style={{ color: "#35af9a" }} />
                )}
                <GreenSwitch
                  checked={lgpdConsent}
                  onChange={async (e) => {
                    handleLGPDConsent(e.target.checked);
                  }}
                  disabled={loadingLGPDConsent}
                />
              </Box>
            </Box>
          </Grid>
          {/* LGPD Ofuscar número telefone para usuários */}
          <Grid xs={12} sm={6} md={4} item>
            <Box className={classes.switchContainer}>
              <Typography className={classes.switchLabel}>
                {i18n.t("settings.settings.LGPD.obfuscatePhoneUser")}
              </Typography>
              <Box className={classes.switchWrapper}>
                {loadingLGPDHideNumber && (
                  <CircularProgress size={16} style={{ color: "#35af9a" }} />
                )}
                <GreenSwitch
                  checked={lgpdHideNumber}
                  onChange={async (e) => {
                    handleLGPDHideNumber(e.target.checked);
                  }}
                  disabled={loadingLGPDHideNumber}
                />
              </Box>
            </Box>
          </Grid>
      </Grid>
      </>
      )}
    </>
  );
}
